import { createFileRoute } from '@tanstack/react-router';
import { MyAttendancePage } from '@/features/attendance/my-attendance-page';
import { guardRoute } from '@/lib/route-guards';

/** `/me/attendance` (FR-WFH-1/3): my WFH requests. */
export const Route = createFileRoute('/_app/me_/attendance')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/me/attendance');
  },
  component: MyAttendancePage,
});
